var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02878 1C5.48921 1 7.33094 5.14388 7.33094 5.60432C7.33094 6.52518 5.94964 7.44604 5.48921 8.36691C5.02878 9.28777 5.94964 10.2086 6.8705 11.1295C7.22964 11.4886 8.71223 12.9712 9.63309 12.5108C10.554 12.0504 11.4748 10.6691 12.3957 10.6691C12.8561 10.6691 17 12.5108 17 12.9712C17 14.8129 15.6187 16.1942 14.2374 16.6547C12.8561 17.1151 11.9353 17.1151 10.0935 16.6547C8.2518 16.1942 6.8705 15.7338 4.56835 13.4317C2.26619 11.1295 1.80576 9.7482 1.34532 7.90647C0.884892 6.06475 0.884892 5.14388 1.34532 3.76259C1.80576 2.38129 3.18705 1 5.02878 1Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a41c2db8eb64047a4a56fa2556f5e849.svg";
export { ForwardRef as ReactComponent };